import React, { Component } from 'react'
import './App.css'
import './reset-password.css'
import axios from 'axios'
import {firebase_url} from './config'
import { auth } from './firebase'
import SetPasswordForm from './set-password-form'


class ResetPassword extends Component {
  state = {
    loading: true,
    errorMessage: '',
    errorCode: '',
    user: null,
    password: '',
    password_2: '',
    validationError: '',
    password_set: false
  };
  handleSubmit = () => {
    let user = auth.currentUser;
    if (user) {
      user.updatePassword(this.state.password)
        .then(() => {
          this.setState({ password_set: true })
        }).catch(error => {
          this.setState({ errorMessage: error.message, errorCode: error.code })
        })
    }
  };
  handleToken = token => {
      return auth.signInWithCustomToken(token).then(() => {
          this.setState({loading: false})
      })
  };
  componentWillMount = () => {
      const { location } = this.props;
      const queryString = require('query-string');
      const qs = queryString.parse(location.search);
      if ('activation_code' in qs) {
          axios.get(`${firebase_url}/activation?activation_token=${atob(qs.activation_code)}`)
              .then(res => {
                  if ('customToken' in res.data) {
                      return this.handleToken(res.data.customToken)
                  }
              }).catch(error => {
              this.setState({errorMessage: error.message, errorCode: error.code, loading: false});
          })
      }
  };

  render() {
    if (this.state.loading) {
      return <div className="large-loader">&nbsp;</div>
    } else if (this.state.password_set) {
      return (
        <div>
          <h1 className="title">Your password has been reset!</h1>
          <p className="subtitle margin margin--bottom-90"><a href='https://sso.canopytax.com/login?page=community'>Go to Community</a> | <a href='https://sso.canopytax.com/login?page=courses'>Go to Courses</a></p>
        </div>
      )
    } else if (this.state.errorMessage !== '') {
      return (
        <div>
          <div className="action-row">
            <div className="error-activation">{this.state.errorMessage}</div>
          </div>
          <div className="action-row activation-text">
            <a onClick={evt => {evt.preventDefault(); this.setState({errorMessage: ''})}}>Go back</a>
          </div>
        </div>
      )
    } else {
      return <div className="activation-modal">
        <div className="title">
          Set your password
        </div>
        <div>
          <SetPasswordForm
            password={this.state.password}
            password_2={this.state.password_2}
            handlePasswordEdits={evt => this.setState({password: evt.target.value})}
            handlePassword2Edits={evt => this.setState({ password_2: evt.target.value })}
            handleSubmit={this.handleSubmit}
          />
        </div>
      </div>
    }
  }
}

export default ResetPassword



// WEBPACK FOOTER //
// ./src/reset-password.js